/**
 * pages/GenerationRapport/GenerationRapport.js
 * Page de génération de rapport simplifiée - basée sur ValidationConflits
 */

import "./GenerationRapport.css";
import { TestRunner } from "../../components/TestRunner/TestRunner.js";

export class GenerationRapport {
  constructor(state) {
    this.state = state;
    this.element = null;
    this.testRunner = null;

    if (window.location.hostname === "localhost") window.debug = this;

    // Écouter les changements d'état
    this.state.on("sourceUpdated", (data) => {
      if (data.source !== "conflictResolutions") {
        this.refresh();
      }
    });
  }

  hasAllData() {
    return this.state.canRunAnalysis();
  }

  refresh() {
    if (this.element) {
      const container = this.element.parentNode;
      this.unmount();
      this.mount(container);
    }
  }

  render() {
    const hasData = this.hasAllData();

    return `
      <div class="validation-conflits-page">
        <div class="page-header">
          <h1 class="page-title">📊 Génération Rapport</h1>
          <p class="page-description">
            ${
              hasData
                ? "Interface de génération des rapports et exports."
                : "Certaines données sont manquantes pour générer un rapport complet."
            }
          </p>
        </div>

        <div class="page-content">
          ${!hasData ? this.renderIncompleteState() : this.renderTestingState()}
        </div>
      </div>
    `;
  }

  renderIncompleteState() {
    return `
      <div class="content-card welcome-state">
        <div class="card-icon">📊</div>
        <h2 class="card-title">Prêt à générer le rapport</h2>
        <p class="card-description">
          Importez vos données pour commencer la génération du rapport 
          d'analyse de votre configuration de fibres optiques.
        </p>
        
        <div class="card-actions">
          <button class="btn btn-primary" onclick="window.app.state.setCurrentPage('config-global')">
            📁 Commencer l'import
          </button>
        </div>
      </div>
    `;
  }

  renderTestingState() {
    return `
      <div class="validation-workspace">
        <div id="test-runner-container">
          <!-- TestRunner sera monté ici -->
        </div>
      </div>
    `;
  }

  renderMissingSources() {
    const sources = this.state.getAllSources();
    const missing = Object.entries(sources)
      .filter(([_key, source]) => source.status !== "success")
      .map(([key, source]) => {
        const names = {
          configTiroirs: "Configuration Tiroirs",
          baseROP: "Base ROP",
          rapportFiberPvReussite: "Rapport Fiber PV Réussite",
          pvReussite: "PV Réussite",
          rapportFiberPvEchec: "Rapport Fiber PV Échec",
          pvEchec: "PV Échec",
          pvHs: "PV Hors Service",
        };
        const statusText = {
          empty: "Non chargé",
          loading: "En cours...",
          error: "Erreur",
        };
        const statusClass = {
          empty: "text-muted",
          loading: "status-warning",
          error: "status-error",
        };

        return `
          <div class="status-item">
            <span class="status-label">${names[key]}:</span>
            <span class="status-value ${statusClass[source.status]}">${statusText[source.status] || source.status}</span>
          </div>
        `;
      });

    return missing.length > 0
      ? missing.join("")
      : '<div class="status-complete">✓ Toutes les sources sont chargées</div>';
  }

  generateDirectly() {
    const workspace = this.element.querySelector(".page-content");
    if (workspace) {
      workspace.innerHTML = this.renderTestingState();
    }

    // Monter le TestRunner
    const container = this.element.querySelector("#test-runner-container");
    if (container) {
      this.testRunner = new TestRunner(this.state);
      this.testRunner.mount(container);
    }
  }

  bindEvents() {
    // Boutons de génération
    const reportBtn = this.element.querySelector("#generate-report-btn");
    const excelBtn = this.element.querySelector("#generate-excel-btn");

    if (reportBtn) {
      reportBtn.addEventListener("click", () => this.generateDirectly());
    }

    if (excelBtn) {
      excelBtn.addEventListener("click", () => this.generateDirectly());
    }
  }

  async mount(container) {
    this.element = document.createElement("div");
    this.element.innerHTML = this.render();
    const mountedElement = this.element.firstElementChild;
    container.appendChild(mountedElement);
    this.element = mountedElement;

    this.bindEvents();

    // Monter le TestRunner si les données sont disponibles
    if (this.hasAllData()) {
      await this.mountTestRunner();
    }

    return this.element;
  }

  async mountTestRunner() {
    const container = this.element.querySelector("#test-runner-container");
    if (container) {
      this.testRunner = new TestRunner(this.state);
      await this.testRunner.mount(container);
    }
  }

  unmount() {
    if (this.testRunner) {
      this.testRunner.unmount();
      this.testRunner = null;
    }

    if (this.element && this.element.parentNode) {
      this.element.parentNode.removeChild(this.element);
    }
    this.element = null;
  }
}
